.icon {
  position: absolute;
}
